import { z } from '../utils/zod.js';
import { planIntervalSchema, planOverridesSchema } from '../pricing-catalogue.js';
import { staffReasonSchema } from './staff.js';
export const adminEnterpriseRequestSchema = z.object({
    enabled: z.boolean().openapi({ description: 'false moves the organization back to FREE and clears overrides' }),
    planOverrides: planOverridesSchema
        .nullable()
        .optional()
        .openapi({ description: 'Omit to keep the stored overrides; null removes them' }),
    contractEndsAt: z
        .string()
        .datetime({ offset: true })
        .nullable()
        .optional()
        .openapi({ description: 'Informational contract end; omit to keep, null clears' }),
    reason: staffReasonSchema,
});
export const adminSubscriptionIntervalRequestSchema = z.object({
    interval: planIntervalSchema,
    reason: staffReasonSchema,
});
export const adminPayAsYouGoRequestSchema = z.object({
    enabled: z.boolean(),
    reason: staffReasonSchema,
});
